import { render, staticRenderFns } from "./ClientPriceElementForm.vue?vue&type=template&id=1dde5e69&"
import script from "./ClientPriceElementForm.vue?vue&type=script&lang=ts&"
export * from "./ClientPriceElementForm.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports